import React from "react";

const EyeProtectFacialCustomer = () => {
  return (
    <div className="organicFacialCustomerContainer">
      <h5>Testimonials from Satisfied Clients</h5>
      <p>
        Don't just take our word for it. Here's what some of our satisfied
        clients have to say about our Eye Protection Facial Services in
        Bangalore:
      </p>
      <div className="organicFacialCustomerContent">
        <p>
          <span className="quote">“</span>I've tried many eye treatments before,
          but SCENT's Eye Protection Facial Services in Bangalore are by far the
          best. My eyes look brighter and more youthful after just one session!{" "}
          <span className="quote">”</span> - <span> Anjali R </span>
        </p>
        <p>
          <span className="quote">“</span> The estheticians at SCENT are truly
          experts in eye care. Their Eye Protection Facial Services in Bangalore
          have helped reduce the puffiness and dark circles I've struggled with
          for years.
          <span className="quote">”</span> - <span>Priya M. </span>
        </p>
        <p>
          <span className="quote">“</span> I love the relaxing atmosphere at
          SCENT. Their Eye Protection Facial Services in Bangalore are not only
          effective but also a wonderful way to unwind and pamper myself.{" "}
          <span className="quote">”</span> - <span>Neha S. </span>
        </p>
      </div>
    </div>
  );
};

export default EyeProtectFacialCustomer;
